import axios from "../interceptors";
import { apiReadComment } from "../../config";
import { logoutUser } from "../../utils/authHandling/logout-user";

export const postCommentRead = async function (language, commentModel) {
  let params = {
    CommentModel: commentModel,
  };
  try {
    const response = await axios.post(apiReadComment, params, {
      headers: {
        "Content-Type": "application/json",        
      },
    });
    if (response.status === 200 || response.status === 201) {
      //the post was saved correctly
      return false;
    } else if (response.status === 400) {
      alert(response.data.Messages);
      return false;
    } else {
      //Session is not valid, therefore logout
      alert("Session is not valid.");
      logoutUser();
      return false;
    }
  } catch (error) {
    console.log(error.response.data.Messages);
    return false;
  }
};
